export function processingFeeLabel(isProcessingFeeRemovalActive: boolean): string {
  return isProcessingFeeRemovalActive ? 'Stripe processing fee' : 'Processing Fee'
}

export function processingFeeAmount(
  legacyFee?: number | null,
  inclusiveProcessingFee?: number | null
): number {
  return inclusiveProcessingFee ?? legacyFee ?? 0
}

export function initialRefundAmount(
  isProcessingFeeRemovalActive: boolean,
  amountDue: number
): number | undefined {
  return isProcessingFeeRemovalActive ? undefined : amountDue
}

export function isValidRefundAmount(amount: number | undefined, amountDue: number): boolean {
  return amount !== undefined && Number.isFinite(amount) && amount > 0 && amount <= amountDue
}
